// Rasterise an <svg> element to a PNG data URL. Linked <image> hrefs are inlined
// first so the canvas is never tainted by cross-origin photos.
const toDataUrl = async (href) => {
  const res = await fetch(href, { credentials: "omit" });
  if (!res.ok) throw new Error("image fetch failed");
  const blob = await res.blob();
  return new Promise((ok, err) => {
    const r = new FileReader();
    r.onload = () => ok(r.result);
    r.onerror = err;
    r.readAsDataURL(blob);
  });
};

export const svgToPng = async (svgEl, { width = 1600, background = "#ffffff" } = {}) => {
  const clone = svgEl.cloneNode(true);
  const images = [...clone.querySelectorAll("image")];
  await Promise.all(
    images.map(async (img) => {
      const href = img.getAttribute("href") || img.getAttribute("xlink:href");
      if (!href || href.startsWith("data:")) return;
      try {
        img.setAttribute("href", await toDataUrl(href));
      } catch {
        img.remove();
      }
    }),
  );
  const vb = (svgEl.getAttribute("viewBox") || "").split(/[\s,]+/).map(Number);
  const rect = svgEl.getBoundingClientRect();
  const vw = vb.length === 4 && vb[2] > 0 ? vb[2] : rect.width || 1000;
  const vh = vb.length === 4 && vb[3] > 0 ? vb[3] : rect.height || 600;
  const height = Math.round((width * vh) / vw);
  clone.setAttribute("width", width);
  clone.setAttribute("height", height);
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(clone))}`;
  const img = new Image();
  await new Promise((ok, err) => {
    img.onload = ok;
    img.onerror = err;
    img.src = src;
  });
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (background) {
    ctx.fillStyle = background;
    ctx.fillRect(0, 0, width, height);
  }
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL("image/png");
};

export const downloadDataUrl = (dataUrl, filename) => {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};
